import type { FaireProductEntity } from "../../entity_types/product";

export const p_bn45md4396: FaireProductEntity = {
  token: "p_bn45md4396",
  type: "product",
  name: "Women's Plush Button Cardigan with Hearts",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/c9e7ceb1d0b31816e0d6b0a1d08b0f309b58884fbb8b393d7397071e1f3d2f31.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4ddda005e4f75f05414486e65832960a071c4b3f28f6fb325353362ada5c918e.jpeg",
    "https://cdn.faire.com/fastly/54c2bb3ab097e3fd73fe0c6e23da01dd9bcb882de32f910b581f314d79440f13.png",
    "https://cdn.faire.com/fastly/e1b113a9321a7f9b15c61c6d7b24045171f18afb77784e145cab8bf5521e3193.png",
    "https://cdn.faire.com/fastly/5e7da547ff168a3b3c5d0beb26cc5fef3a05fcabda3a0be394b7ee6cb629b1b4.png",
    "https://cdn.faire.com/fastly/2ff7121a37833b93752cf211d65e592c2536b0f9db7e176dbb49487cb47218af.jpeg",
    "https://cdn.faire.com/fastly/ccd7087a8d24deeb04d6c5fd577197c11b13749e4e15a86697b747ac5ee9a39f.jpeg",
    "https://cdn.faire.com/fastly/a26a2921eaae45cd161828927e9349c4b334cc81801e615134d540817cd2acbd.png",
    "https://cdn.faire.com/fastly/2491ea6314534f3178c3d3eb5483acca2c0e7253ebd6bb31fae19e3754019980.png"
  ],
  priceDollars: 55,
  description: "A little charm goes a long way, and this cardigan delivers it effortlessly. Playful yet polished, it's the layer you'll reach for when you want comfort with a touch of personality.\n\nFabrication:\nCrafted from Softies' signature Marshmallow fabric, this cardigan is ultra-plush, cloud-like, and irresistibly soft to the touch.\n\nFeatures:\n● Cropped cardigan silhouette offers a modern, flattering fit\n● Heart detailing adds a playful and charming touch\n● Button-front design allows for versatile styling options\n● Ribbed trim creates a polished, finished look\n\nMaterials & Care:\n● 100% Polyester\n● Machine wash cold with like colors\n● Tumble dry low; do not bleach\n\nBest For:\n● Valentine's gifting and seasonal styling\n● Layering over lounge and sleepwear\n● Adding a whimsical touch to everyday comfort\n",
  tags: [],
  msrpDollars: 119,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:17.346Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
